<template>
    <transition name="fade">
        <div class="NotificationBar alert text-white" :class="notificationTypeClass">
            <span v-if="notification.title" class="font-weight-semibold">{{notification.title}}.</span>
            {{notification.message}}
        </div>
    </transition>
</template>
<script>
    import {mapActions} from 'vuex';
    export default {
        name: 'NotificationBar',
        props: {
            notification: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                timeout: null
            }
        },

        mounted() {
            this.timeout = setTimeout(() => this.remove(this.notification.id), 5000);
        },

        beforeDestroy() {
            clearTimeout(this.timeout);
        },

        computed: {
            notificationTypeClass() {
                let className = 'bg-';
                switch (this.notification.type) {

                    case 'error':
                        className += 'danger';
                        break;
                    default:
                        className += this.notification.type;
                        break
                }

                return className;
            }
        },

        methods: mapActions('Notification', ['remove'])
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>